import { EventEmitter } from '@visiba/std';
import { PRESENTATION_DEBUG_HOOK, PRESENTATION_DEBUG_REF } from './subscribable/common';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
globalThis[PRESENTATION_DEBUG_REF] ?? (globalThis[PRESENTATION_DEBUG_REF] = new WeakSet());
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
globalThis[PRESENTATION_DEBUG_HOOK] ?? (globalThis[PRESENTATION_DEBUG_HOOK] = new EventEmitter());
